/* 9MILLY - LOOKBOOK w formie stories (sections/lookbook.liquid).
   Pełnoekranowy widok jak relacje na Instagramie: paski postępu u góry,
   stuknięcie w prawo/lewo zmienia kadr NATYCHMIAST (bez animacji),
   przytrzymanie = pauza, przeciągnięcie w dół = zamknij, przeciągnięcie w
   bok = następny/poprzedni drop (tu jest animacja). Do tego:
   produkty w kadrze (kropki na zdjęciu + szklane chipy; wyprzedane są
   oznaczone) i "Cały look" - dodanie dostępnych produktów z kadru do
   koszyka jednym kliknięciem.
   Jeden drop = jedna sekcja na stronie; stories łączą wszystkie dropy ze
   strony. Kliknięcie zdjęcia (data-lb-open + data-lb-slide) otwiera widok od
   tego kadru; #look-D-S w adresie (np. z okładki na stronie głównej)
   otwiera drop D od kadru S. */

const SEEN_KEY = 'nm-lookbook-seen';
const HOLD_MS = 220;
const REDUCE_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const ICON = {
  close:
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M4 4l10 10M14 4L4 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
  pause:
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><rect x="3.5" y="2.5" width="3" height="11" rx="1"/><rect x="9.5" y="2.5" width="3" height="11" rx="1"/></svg>',
  play:
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M4 2.6v10.8a.6.6 0 0 0 .92.5l8.4-5.4a.6.6 0 0 0 0-1L4.92 2.1A.6.6 0 0 0 4 2.6Z"/></svg>',
  mute:
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M3 7h2.5L9 4v10l-3.5-3H3V7Z" fill="currentColor"/><path d="M12 6.5l4 5M16 6.5l-4 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  sound:
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M3 7h2.5L9 4v10l-3.5-3H3V7Z" fill="currentColor"/><path d="M12 6.5c1.2 1.4 1.2 3.6 0 5M14.3 4.8c2.2 2.4 2.2 5.9 0 8.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  bag:
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M3.5 6.5h11l-.8 8a1 1 0 0 1-1 .9H5.3a1 1 0 0 1-1-.9l-.8-8Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M6.5 6.5V5a2.5 2.5 0 0 1 5 0v1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  prev:
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12 4l-6 6 6 6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  next:
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M8 4l6 6-6 6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
};

const esc = (value) =>
  String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

const plural = (n, one, few, many) => {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (n === 1) return one;
  if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return few;
  return many;
};

// Strona lookbooka ma wiele sekcji (jeden drop = jedna sekcja). Stories
// przechodzą przez wszystkie z nich, w kolejności na stronie.
function pageRoots() {
  return [...document.querySelectorAll('[data-nm-lb][data-layout="page"]')];
}

function collectChapters(root) {
  const roots = pageRoots();
  const list = roots.includes(root) ? roots : [root];
  const chapters = [];
  const offsets = new Map();
  list.forEach((node) => {
    offsets.set(node, chapters.length);
    const dataNode = node.querySelector('[data-lb-data]');
    if (!dataNode) return;
    try {
      const data = JSON.parse(dataNode.textContent || '[]');
      if (Array.isArray(data)) chapters.push(...data.filter((c) => c.slides && c.slides.length));
    } catch (error) {
      /* uszkodzone dane jednego dropu nie blokują reszty */
    }
  });
  return { chapters, offsets };
}

function readSeen() {
  try {
    return JSON.parse(localStorage.getItem(SEEN_KEY) || '[]');
  } catch (error) {
    return [];
  }
}

function markSeen(name) {
  try {
    const seen = readSeen();
    if (!seen.includes(name)) {
      seen.push(name);
      localStorage.setItem(SEEN_KEY, JSON.stringify(seen));
    }
  } catch (error) {
    /* localStorage może być zablokowany - nic się nie dzieje */
  }
  refreshSeen();
}

function refreshSeen() {
  const seen = readSeen();
  document.querySelectorAll('[data-lb-open]').forEach((node) => {
    node.classList.toggle('is-seen', seen.includes(node.getAttribute('data-lb-name')));
  });
}

class StoryViewer {
  isOpen = false;
  built = false;
  chapters = [];
  ci = 0;
  si = 0;
  elapsed = 0;
  dur = 5000;
  last = 0;
  raf = 0;
  loading = false;
  userPaused = false;
  holding = false;
  sheetOpen = false;
  muted = true;
  video = null;
  pushed = false;
  lastSize = '';
  token = 0;

  open(root, chapterIndex, opener, slideIndex = 0) {
    this.chapters = collectChapters(root).chapters;
    if (!this.chapters.length) return;
    this.root = root;
    this.opener = opener || null;
    this.seconds = Number(root.dataset.seconds) || 5;
    this.currency = root.dataset.currency || 'PLN';

    if (!this.built) this.#build();
    this.ac = new AbortController();
    this.#bindGlobal(this.ac.signal);

    this.userPaused = false;
    this.holding = false;
    this.sheetOpen = false;
    this.isOpen = true;
    this.el.hidden = false;
    this.#syncPauseIcon();
    document.documentElement.classList.add('nm-lb-open');
    window.requestAnimationFrame(() => this.el.classList.add('is-open'));

    try {
      window.history.pushState({ nmLb: true }, '');
      this.pushed = true;
    } catch (error) {
      this.pushed = false;
    }

    const ci = Math.min(Math.max(chapterIndex, 0), this.chapters.length - 1);
    const si = Math.min(Math.max(slideIndex, 0), this.chapters[ci].slides.length - 1);
    this.#goChapter(ci, si, null);
    this.btnClose.focus({ preventScroll: true });
  }

  close(fromPop = false) {
    if (!this.isOpen) return;
    this.isOpen = false;
    window.cancelAnimationFrame(this.raf);
    this.#stopVideo();
    this.#closeSheet(true);
    this.el.classList.remove('is-open', 'is-paused', 'is-holding');
    document.documentElement.classList.remove('nm-lb-open');
    this.ac?.abort();

    const wasPushed = this.pushed;
    this.pushed = false;
    if (wasPushed && !fromPop) {
      try {
        window.history.back();
      } catch (error) {
        /* brak historii - ignorujemy */
      }
    }

    window.setTimeout(() => {
      if (this.isOpen) return;
      this.el.hidden = true;
      this.media.innerHTML = '';
    }, 300);

    if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
  }

  /* ---------------------------------------------------------------- */
  /* Budowa                                                            */
  /* ---------------------------------------------------------------- */

  #build() {
    this.built = true;
    this.el = document.createElement('div');
    this.el.className = 'nm-lbv';
    this.el.hidden = true;
    this.el.setAttribute('role', 'dialog');
    this.el.setAttribute('aria-modal', 'true');
    this.el.setAttribute('aria-label', 'Lookbook');
    this.el.innerHTML = `
      <div class="nm-lbv__ambient" data-ambient></div>
      <button class="nm-lbv__nav nm-lbv__nav--prev nm-lbv__ui" type="button" data-act="prev" aria-label="Poprzedni kadr">${ICON.prev}</button>
      <div class="nm-lbv__stage" data-stage>
        <div class="nm-lbv__media" data-media></div>
        <div class="nm-lbv__scrim nm-lbv__scrim--top"></div>
        <div class="nm-lbv__scrim nm-lbv__scrim--bottom"></div>
        <div class="nm-lbv__dots nm-lbv__ui" data-dots></div>
        <div class="nm-lbv__bars nm-lbv__ui" data-bars></div>
        <div class="nm-lbv__top nm-lbv__ui">
          <div class="nm-lbv__who">
            <span class="nm-lbv__brand">NineMilly</span>
            <span class="nm-lbv__chapter" data-chapter></span>
          </div>
          <button class="nm-lbv__btn" type="button" data-act="sound" hidden aria-label="Włącz dźwięk">${ICON.mute}</button>
          <button class="nm-lbv__btn" type="button" data-act="pause" aria-label="Wstrzymaj">${ICON.pause}</button>
          <button class="nm-lbv__btn" type="button" data-act="close" aria-label="Zamknij lookbook">${ICON.close}</button>
        </div>
        <div class="nm-lbv__bottom nm-lbv__ui" data-bottom></div>
        <div class="nm-lbv__veil" data-veil></div>
        <div class="nm-lbv__sheet nm-lbv__ui" data-sheet role="region" aria-label="Zakup"></div>
      </div>
      <button class="nm-lbv__nav nm-lbv__nav--next nm-lbv__ui" type="button" data-act="next" aria-label="Następny kadr">${ICON.next}</button>
    `;
    document.body.appendChild(this.el);

    const q = (sel) => this.el.querySelector(sel);
    this.stage = q('[data-stage]');
    this.media = q('[data-media]');
    this.ambient = q('[data-ambient]');
    this.bars = q('[data-bars]');
    this.dots = q('[data-dots]');
    this.bottom = q('[data-bottom]');
    this.chapterLabel = q('[data-chapter]');
    this.btnClose = q('[data-act="close"]');
    this.btnPause = q('[data-act="pause"]');
    this.btnSound = q('[data-act="sound"]');
    this.veil = q('[data-veil]');
    this.sheet = q('[data-sheet]');

    this.el.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target === this.el || target.hasAttribute('data-ambient')) {
        this.close();
        return;
      }
      const act = target.closest('[data-act]')?.getAttribute('data-act');
      if (act === 'close') this.close();
      else if (act === 'next') this.#next();
      else if (act === 'prev') this.#prev();
      else if (act === 'pause') this.#togglePause();
      else if (act === 'sound') this.#toggleSound();

      const chip = target.closest('[data-lb-chip]');
      if (chip) this.#openProductSheet(chip.getAttribute('data-lb-chip'));
      if (target.closest('[data-lb-look]')) this.#openLookSheet();
    });

    this.veil.addEventListener('click', () => this.#closeSheet());
    this.sheet.inert = true;
    this.sheet.addEventListener('change', (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.type === 'radio') {
        this.lastSize = input.dataset.label || '';
        input.closest('.nm-lbv__item')?.classList.remove('is-missing');
      }
    });

    this.stage.addEventListener('pointerdown', (e) => this.#onDown(e));
    this.stage.addEventListener('pointermove', (e) => this.#onMove(e));
    this.stage.addEventListener('pointerup', (e) => this.#onUp(e));
    this.stage.addEventListener('pointercancel', (e) => this.#onUp(e, true));
    this.stage.addEventListener('animationend', (e) => {
      if (e.target === this.stage) this.stage.classList.remove('is-from-right', 'is-from-left');
    });
    this.stage.addEventListener('contextmenu', (e) => e.preventDefault());
  }

  #bindGlobal(signal) {
    document.addEventListener(
      'keydown',
      (event) => {
        if (!this.isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          if (this.sheetOpen) this.#closeSheet();
          else this.close();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.#next();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.#prev();
        } else if (event.key === ' ' && !(event.target instanceof HTMLButtonElement) && !(event.target instanceof HTMLInputElement)) {
          event.preventDefault();
          this.#togglePause();
        } else if (event.key === 'Tab') {
          this.#trapFocus(event);
        }
      },
      { signal }
    );

    window.addEventListener(
      'popstate',
      () => {
        if (this.isOpen) {
          this.pushed = false;
          this.close(true);
        }
      },
      { signal }
    );

    document.addEventListener('visibilitychange', () => this.#syncPlayback(), { signal });
  }

  #trapFocus(event) {
    const nodes = [...this.el.querySelectorAll('button, a[href], input')].filter(
      (node) => !node.disabled && node.offsetParent !== null && !node.closest('[hidden]')
    );
    if (!nodes.length) return;
    const first = nodes[0];
    const lastNode = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      lastNode.focus();
    } else if (!event.shiftKey && document.activeElement === lastNode) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---------------------------------------------------------------- */
  /* Nawigacja                                                         */
  /* ---------------------------------------------------------------- */

  get chapter() {
    return this.chapters[this.ci];
  }

  get slide() {
    return this.chapter.slides[this.si];
  }

  #goChapter(ci, si, direction) {
    this.ci = ci;
    markSeen(this.chapter.title);
    this.chapterLabel.textContent = this.chapter.sub ? `${this.chapter.title} · ${this.chapter.sub}` : this.chapter.title;
    this.#renderBars();

    if (direction && !REDUCE_MOTION) {
      this.stage.classList.remove('is-from-right', 'is-from-left');
      void this.stage.offsetWidth;
      this.stage.classList.add(direction === 'right' ? 'is-from-right' : 'is-from-left');
    }
    this.#goSlide(si === 'last' ? this.chapter.slides.length - 1 : si);
  }

  #goSlide(si) {
    this.si = si;
    const slide = this.slide;
    this.token += 1;
    const token = this.token;

    [...this.bars.children].forEach((bar, index) => {
      const fill = bar.firstElementChild;
      fill.style.transform = index < si ? 'scaleX(1)' : 'scaleX(0)';
    });

    this.#stopVideo();
    this.elapsed = 0;
    this.dur = this.seconds * 1000;
    this.loading = true;
    this.last = performance.now();

    const old = [...this.media.children];
    const layer = this.#makeLayer(slide, token, old);
    this.media.appendChild(layer);
    // Jak na Instagramie: stuknięcie zmienia kadr natychmiast, bez przejścia.
    // Animacja jest tylko przy przeciągnięciu w bok (zmiana dropu).
    // (poprzedni kadr znika dopiero, gdy nowy jest wczytany - bez czarnej klatki)
    window.setTimeout(() => old.forEach((node) => node.remove()), 2500);

    this.ambient.style.backgroundImage = slide.image ? `url("${slide.image}")` : slide.poster ? `url("${slide.poster}")` : 'none';

    this.#renderBottom();
    this.#renderDots();
    this.btnSound.hidden = !slide.video;
    this.#syncSoundIcon();
    this.#preloadNext();

    window.cancelAnimationFrame(this.raf);
    this.raf = window.requestAnimationFrame(this.#tick);
  }

  #next() {
    if (!this.isOpen) return;
    if (this.si < this.chapter.slides.length - 1) this.#goSlide(this.si + 1);
    else if (this.ci < this.chapters.length - 1) this.#goChapter(this.ci + 1, 0, null);
    else this.close();
  }

  #prev() {
    if (!this.isOpen) return;
    if (this.elapsed > 1500) this.#goSlide(this.si);
    else if (this.si > 0) this.#goSlide(this.si - 1);
    else if (this.ci > 0) this.#goChapter(this.ci - 1, 'last', null);
    else this.#goSlide(0);
  }

  #nextChapter() {
    if (this.ci < this.chapters.length - 1) this.#goChapter(this.ci + 1, 0, 'right');
    else this.close();
  }

  #prevChapter() {
    if (this.ci > 0) this.#goChapter(this.ci - 1, 0, 'left');
    else this.#goSlide(0);
  }

  /* ---------------------------------------------------------------- */
  /* Media i czas                                                      */
  /* ---------------------------------------------------------------- */

  #makeLayer(slide, token, old = []) {
    const layer = document.createElement('div');
    layer.className = 'nm-lbv__layer';
    const wide = window.innerWidth > 749;
    const ready = () => {
      if (token !== this.token) return;
      this.loading = false;
      this.last = performance.now();
      layer.classList.add('is-ready');
      old.forEach((node) => node.remove());
    };

    if (slide.video) {
      const video = document.createElement('video');
      video.muted = this.muted;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'auto';
      if (slide.poster) video.poster = slide.poster;
      video.src = slide.video;
      video.addEventListener('loadeddata', () => {
        if (token !== this.token) return;
        if (Number.isFinite(video.duration) && video.duration > 0) this.dur = video.duration * 1000;
        ready();
        this.#syncPlayback();
      });
      video.addEventListener('error', () => {
        if (token === this.token) window.setTimeout(() => token === this.token && this.#next(), 400);
      });
      this.video = video;
      layer.appendChild(video);
    } else {
      const img = document.createElement('img');
      img.alt = slide.alt || '';
      img.decoding = 'async';
      img.style.objectPosition = slide.focal || '50% 50%';
      img.addEventListener('load', ready);
      img.addEventListener('error', () => {
        if (token === this.token) window.setTimeout(() => token === this.token && this.#next(), 400);
      });
      img.src = (wide ? slide.imageLg : slide.image) || slide.image || '';
      layer.appendChild(img);
      if (img.complete && img.naturalWidth) ready();
    }
    return layer;
  }

  #preloadNext() {
    const nextSlide =
      this.chapter.slides[this.si + 1] || (this.chapters[this.ci + 1] && this.chapters[this.ci + 1].slides[0]);
    if (nextSlide && !nextSlide.video) {
      const img = new Image();
      img.src = (window.innerWidth > 749 ? nextSlide.imageLg : nextSlide.image) || nextSlide.image || '';
    }
  }

  #isPaused() {
    return this.userPaused || this.holding || this.sheetOpen || document.hidden;
  }

  #syncPlayback() {
    const paused = this.#isPaused();
    this.el.classList.toggle('is-paused', paused);
    if (!this.video) return;
    if (paused) this.video.pause();
    else {
      const playing = this.video.play();
      if (playing && typeof playing.catch === 'function') playing.catch(() => {});
    }
  }

  #stopVideo() {
    if (this.video) {
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.video = null;
    }
  }

  #tick = (now) => {
    this.raf = 0;
    if (!this.isOpen) return;
    const dt = Math.min(now - this.last, 100);
    this.last = now;

    if (!this.loading && !this.#isPaused()) {
      if (this.video && this.video.readyState >= 2) {
        this.elapsed = this.video.currentTime * 1000;
        if (Number.isFinite(this.video.duration) && this.video.duration > 0) this.dur = this.video.duration * 1000;
      } else {
        this.elapsed += dt;
      }
    }

    const progress = this.dur > 0 ? Math.min(1, this.elapsed / this.dur) : 0;
    const fill = this.bars.children[this.si]?.firstElementChild;
    if (fill) fill.style.transform = `scaleX(${progress})`;

    if (progress >= 1 && !this.loading) {
      this.#next();
      return;
    }
    this.raf = window.requestAnimationFrame(this.#tick);
  };

  #togglePause() {
    this.userPaused = !this.userPaused;
    this.#syncPauseIcon();
    this.#syncPlayback();
  }

  #syncPauseIcon() {
    if (!this.btnPause) return;
    this.btnPause.innerHTML = this.userPaused ? ICON.play : ICON.pause;
    this.btnPause.setAttribute('aria-label', this.userPaused ? 'Wznów' : 'Wstrzymaj');
  }

  #toggleSound() {
    this.muted = !this.muted;
    if (this.video) this.video.muted = this.muted;
    this.#syncSoundIcon();
  }

  #syncSoundIcon() {
    this.btnSound.innerHTML = this.muted ? ICON.mute : ICON.sound;
    this.btnSound.setAttribute('aria-label', this.muted ? 'Włącz dźwięk' : 'Wycisz');
  }

  /* ---------------------------------------------------------------- */
  /* Renderowanie                                                      */
  /* ---------------------------------------------------------------- */

  #renderBars() {
    this.bars.innerHTML = this.chapter.slides.map(() => '<i class="nm-lbv__bar"><b></b></i>').join('');
  }

  #money(cents) {
    try {
      return new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(0)} zł`;
    }
  }

  #findProduct(handle) {
    return this.slide.products.find((p) => p.handle === handle) || null;
  }

  #renderBottom() {
    const slide = this.slide;
    const parts = [];
    if (slide.caption) parts.push(`<p class="nm-lbv__caption">${esc(slide.caption)}</p>`);

    if (slide.products.length) {
      parts.push(
        '<ul class="nm-lbv__chips" role="list">' +
          slide.products
            .map(
              (p) => `
            <li>
              <button class="nm-lbv__chip${p.available === false ? ' is-sold' : ''}" type="button" data-lb-chip="${esc(p.handle)}" aria-label="${p.available === false ? 'Wyprzedane' : 'Kup'}: ${esc(p.title)}">
                <span class="nm-lbv__chipimg">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}</span>
                <span class="nm-lbv__chiptext">
                  <span class="nm-lbv__chiptitle">${esc(p.title)}</span>
                  <span class="nm-lbv__chipprice">${p.available === false ? 'Wyprzedane' : esc(p.price)}</span>
                </span>
              </button>
            </li>`
            )
            .join('') +
          '</ul>'
      );
    }

    const all = slide.products.filter((p) => p.available !== false);
    if (all.length >= 2) {
      const total = all.reduce((sum, p) => sum + (Number(p.cents) || 0), 0);
      parts.push(
        `<button class="nm-lbv__look" type="button" data-lb-look>${ICON.bag}<span>Cały look · ${all.length} ${plural(
          all.length,
          'produkt',
          'produkty',
          'produktów'
        )} · ${esc(this.#money(total))}</span></button>`
      );
    }
    this.bottom.innerHTML = parts.join('');
  }

  #renderDots() {
    const slide = this.slide;
    this.dots.innerHTML = slide.dots
      .map((dot) => {
        const product = slide.products.find((p) => p.handle === dot.handle);
        if (!product) return '';
        return `<button class="nm-lbv__dot" type="button" style="left:${Number(dot.x)}%;top:${Number(dot.y)}%" data-lb-chip="${esc(
          dot.handle
        )}" aria-label="Kup: ${esc(product.title)}"></button>`;
      })
      .join('');
  }

  /* ---------------------------------------------------------------- */
  /* Arkusz zakupu                                                     */
  /* ---------------------------------------------------------------- */

  #openProductSheet(handle) {
    const product = this.#findProduct(handle);
    if (product) this.#openSheet([product], 'product');
  }

  #openLookSheet() {
    this.#openSheet(this.slide.products.filter((p) => p.available !== false), 'look');
  }

  #openSheet(products, mode) {
    if (!products.length) return;
    this.sheetProducts = products;
    this.sheetMode = mode;
    const total = products.reduce((sum, p) => sum + (Number(p.cents) || 0), 0);
    const title = mode === 'look' ? 'Cały look' : 'Dodaj do koszyka';

    const items = products
      .map((p, index) => {
        const preselected = p.variants.find((v) => v.available && v.label === this.lastSize);
        const only = p.variants.length === 1 && p.variants[0].available ? p.variants[0] : null;
        const checkedId = preselected ? preselected.id : only ? only.id : null;
        const sizes = p.variants
          .map(
            (v) => `
          <label class="nm-lbv__size">
            <input type="radio" name="lb-size-${index}" value="${v.id}" data-label="${esc(v.label)}" ${v.available ? '' : 'disabled'} ${
              v.id === checkedId ? 'checked' : ''
            }>
            <span>${esc(v.label)}</span>
          </label>`
          )
          .join('');
        return `
        <li class="nm-lbv__item" data-index="${index}">
          <a class="nm-lbv__itemimg" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${
            p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''
          }</a>
          <div>
            <a class="nm-lbv__itemtitle" href="${esc(p.url)}">${esc(p.title)}</a>
            <fieldset class="nm-lbv__sizes"><legend class="nm-lbv__sr">Rozmiar: ${esc(p.title)}</legend>${sizes}</fieldset>
          </div>
          <span class="nm-lbv__itemprice">${p.available === false ? 'Wyprzedane' : esc(p.price)}</span>
        </li>`;
      })
      .join('');

    this.sheet.innerHTML = `
      <div class="nm-lbv__sheethead">
        <h3 class="nm-lbv__sheettitle">${title}</h3>
        <button class="nm-lbv__btn" type="button" data-sheet-close aria-label="Zamknij">${ICON.close}</button>
      </div>
      <ul class="nm-lbv__sheetlist" role="list">${items}</ul>
      <div class="nm-lbv__sheetfoot">
        <div class="nm-lbv__sum"><span>Razem</span><strong>${esc(this.#money(total))}</strong></div>
        <button class="nm-lbv__add" type="button" data-sheet-add ${products.every((p) => p.available === false) ? 'disabled' : ''}>${
          products.every((p) => p.available === false) ? 'Wyprzedane' : mode === 'look' ? 'Dodaj cały look do koszyka' : 'Dodaj do koszyka'
        }</button>
        <p class="nm-lbv__msg" role="status" aria-live="polite" data-sheet-msg></p>
      </div>`;

    this.sheet.querySelector('[data-sheet-close]').addEventListener('click', () => this.#closeSheet());
    this.sheet.querySelector('[data-sheet-add]').addEventListener('click', () => this.#addToCart());

    this.sheet.inert = false;
    this.sheetOpen = true;
    this.veil.classList.add('is-on');
    this.sheet.classList.add('is-open');
    this.#syncPlayback();
    this.sheet.querySelector('[data-sheet-close]').focus({ preventScroll: true });
  }

  #closeSheet(silent = false) {
    if (!this.sheetOpen) return;
    this.sheetOpen = false;
    this.veil.classList.remove('is-on');
    this.sheet.classList.remove('is-open');
    this.sheet.inert = true;
    if (!silent) {
      this.last = performance.now();
      this.#syncPlayback();
    }
  }

  async #addToCart() {
    const button = this.sheet.querySelector('[data-sheet-add]');
    const message = this.sheet.querySelector('[data-sheet-msg]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const items = [];
    let firstMissing = null;
    this.sheet.querySelectorAll('.nm-lbv__item').forEach((node) => {
      const checked = node.querySelector('input[type="radio"]:checked');
      if (checked) items.push({ id: Number(checked.value), quantity: 1 });
      else {
        node.classList.add('is-missing');
        firstMissing = firstMissing || node;
      }
    });

    if (firstMissing) {
      message.textContent = 'Wybierz rozmiar przy każdym produkcie.';
      message.setAttribute('data-error', '');
      firstMissing.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }

    message.removeAttribute('data-error');
    message.textContent = '';
    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'Dodaję…';

    try {
      const sections = [...document.querySelectorAll('cart-items-component')]
        .map((node) => node instanceof HTMLElement && node.dataset.sectionId)
        .filter(Boolean)
        .join(',');

      const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections }),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description || data.message || 'Nie udało się dodać do koszyka.');

      const cart = await (await fetch('/cart.js')).json();
      try {
        const { CartAddEvent } = await import('@theme/events');
        document.dispatchEvent(
          new CartAddEvent(cart, 'nm-lookbook', { source: 'nm-lookbook', itemCount: items.length, sections: data.sections })
        );
      } catch (error) {
        /* licznik koszyka odświeży się przy następnym wejściu */
      }

      button.textContent = 'Dodano ✓';
      message.innerHTML = `Dodano do koszyka. <a href="${esc(window.Theme?.routes?.cart_url || '/cart')}">Zobacz koszyk</a>`;
    } catch (error) {
      message.setAttribute('data-error', '');
      message.textContent = error instanceof Error ? error.message : 'Nie udało się dodać do koszyka.';
      button.textContent = original;
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        if (button.textContent === 'Dodano ✓') button.textContent = original;
      }, 2200);
    }
  }

  /* ---------------------------------------------------------------- */
  /* Gesty                                                             */
  /* ---------------------------------------------------------------- */

  #onDown(event) {
    if (this.sheetOpen) return;
    if (event.target instanceof Element && event.target.closest('.nm-lbv__ui')) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
    this.holdTimer = window.setTimeout(() => {
      this.holding = true;
      this.el.classList.add('is-holding');
      this.#syncPlayback();
    }, HOLD_MS);
    try {
      this.stage.setPointerCapture(event.pointerId);
    } catch (error) {
      /* nie krytyczne */
    }
  }

  #onMove(event) {
    const p = this.pointer;
    if (!p || p.id !== event.pointerId) return;
    const dx = event.clientX - p.x;
    const dy = event.clientY - p.y;
    if (!p.moved && Math.hypot(dx, dy) > 12) {
      p.moved = true;
      window.clearTimeout(this.holdTimer);
    }
    if (p.moved && dy > 0 && Math.abs(dy) > Math.abs(dx)) {
      this.stage.classList.add('is-dragging');
      this.stage.style.transform = `translateY(${dy * 0.6}px) scale(${Math.max(0.85, 1 - dy / 1400)})`;
    }
  }

  #onUp(event, cancelled = false) {
    const p = this.pointer;
    if (!p || p.id !== event.pointerId) return;
    this.pointer = null;
    window.clearTimeout(this.holdTimer);
    const wasHolding = this.holding;
    this.holding = false;
    this.el.classList.remove('is-holding');
    this.last = performance.now();
    this.#syncPlayback();

    const dx = event.clientX - p.x;
    const dy = event.clientY - p.y;
    const dragged = this.stage.classList.contains('is-dragging');
    if (dragged) {
      this.stage.classList.remove('is-dragging');
      this.stage.classList.add('is-reset');
      this.stage.style.transform = '';
      window.setTimeout(() => this.stage.classList.remove('is-reset'), 300);
    }
    if (cancelled) return;

    if (dy > 110 && Math.abs(dy) > Math.abs(dx)) {
      this.close();
    } else if (Math.abs(dx) > 70 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) this.#nextChapter();
      else this.#prevChapter();
    } else if (!wasHolding && !p.moved) {
      const rect = this.stage.getBoundingClientRect();
      if (event.clientX - rect.left < rect.width * 0.33) this.#prev();
      else this.#next();
    }
  }
}

const viewer = new StoryViewer();

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const openBtn = target.closest('[data-lb-open]');
  const playAll = target.closest('[data-lb-play-all]');
  const trigger = openBtn || playAll;
  if (!trigger) return;
  const root = trigger.closest('[data-nm-lb]');
  if (!root) return;
  event.preventDefault();
  if (openBtn) {
    const base = collectChapters(root).offsets.get(root) || 0;
    viewer.open(root, base, trigger, Number(openBtn.getAttribute('data-lb-slide')) || 0);
  } else {
    viewer.open(root, 0, trigger, 0);
  }
});

function init() {
  refreshSeen();
  // #look-D-S (np. z okładki na stronie głównej) = otwórz drop D od kadru S
  const match = /^#look-(\d+)(?:-(\d+))?$/.exec(window.location.hash);
  if (match) {
    const root = pageRoots()[0];
    if (root) viewer.open(root, Number(match[1]) - 1, null, Number(match[2] || 1) - 1);
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

document.addEventListener('shopify:section:load', () => {
  refreshSeen();
});
